'use client';

import { Box, BoxProps } from '@chakra-ui/react';
import { useTokens } from '@mezzoforte/forge';

const { breakpoints } = useTokens.huutokaupat;

export type ShowResponsiveProps = Partial<
  Record<'sm' | 'md' | 'lg' | 'xl' | 'smHide' | 'mdHide' | 'lgHide' | 'xlHide', true>
> &
  BoxProps;

export function ShowResponsive({
  children,
  smHide,
  mdHide,
  lgHide,
  xlHide,
  sm,
  md,
  lg,
  xl,
  ...props
}: ShowResponsiveProps) {
  const display = (smHide ?? mdHide ?? lgHide ?? xlHide) ? 'block' : 'none';

  return (
    <Box
      display={display}
      sx={{
        ...(sm && { [`@media screen and (min-width: ${breakpoints.sm})`]: { display: 'block' } }),
        ...(md && { [`@media screen and (min-width: ${breakpoints.md})`]: { display: 'block' } }),
        ...(lg && { [`@media screen and (min-width: ${breakpoints.lg})`]: { display: 'block' } }),
        ...(xl && { [`@media screen and (min-width: ${breakpoints.xl})`]: { display: 'block' } }),
        ...(smHide && { [`@media screen and (min-width: ${breakpoints.sm})`]: { display: 'none' } }),
        ...(mdHide && { [`@media screen and (min-width: ${breakpoints.md})`]: { display: 'none' } }),
        ...(lgHide && { [`@media screen and (min-width: ${breakpoints.lg})`]: { display: 'none' } }),
        ...(xlHide && { [`@media screen and (min-width: ${breakpoints.xl})`]: { display: 'none' } }),
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
